<template>
  <div>
    <FreeBooks code="4" />
  </div>
</template>

<script>
import FreeBooks from './freeBooks';// 有声识字
export default {
  components: {
    FreeBooks
  }
};
</script>

